import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "position-relative h-100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, { title: _ctx._title }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: "Schließen",
                onClick: _ctx.currentWindow.close,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
                    : _createCommentVNode("", true),
                (_ctx.contentHtml)
                    ? (_openBlock(), _createBlock(_component_g_dynamic_html, {
                        key: 1,
                        template: _ctx.contentHtml,
                        templateProps: { dataObject: _ctx.dataObject }
                    }, null, 8, ["template", "templateProps"]))
                    : _createCommentVNode("", true)
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
